import React, {useState} from "react";
import CoalesceIdentityFunction from "../../../helper/coalesceIdentityFunction";
import CoalesceFunction from "../../../helper/coalesceFunction";
import useEffectExceptInitial from "../../hooks/useEffectExceptInitial";

function select(event) {
    event.target.select();
}

function blurOnEnter(event) {
    if(event.key === 'Enter') {
        event.target.blur();
    }
}

export default function Editable({ value, formatter, parser, onChange, onChangeMeta }) {
    const [editing, setEditing] = useState(false);
    const [internalValue, setInternalValue] = useState(value);

    useEffectExceptInitial(
        () => setInternalValue(value),
        [value]
    )

    onChange = CoalesceFunction(onChange);
    parser = CoalesceIdentityFunction(parser);

    if(!editing) {
        return <div className={'editable-text-field pl-1'}
                    onClick={setEditing.bind(null, true)}>
            {CoalesceIdentityFunction(formatter)(internalValue)}
        </div>
    }
    else {
        function saveChanges(event) {
            const newValue = parser(event.target.value);
            onChange(newValue, onChangeMeta);
            setEditing(false);
            setInternalValue(newValue);
        }

        return <input className={'editable-text-field'} onKeyDown={blurOnEnter} onBlur={saveChanges} autoFocus onFocus={select} defaultValue={CoalesceIdentityFunction(formatter)(internalValue)} />
    }
}
